const ROLES = {
  CompanyManager: 1,
  CityManager: 2,
  Admin: 3,
} as const;

export type TUserRole = (typeof ROLES)[keyof typeof ROLES];

export default ROLES;
